import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-photo',
  templateUrl: './add-photo.component.html',
  styleUrls: ['./add-photo.component.scss']
})
export class AddPhotoComponent implements OnInit {
  croppedImage: Blob;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit(): void {
  }

  onCroppedImage(event) {
    this.croppedImage = event;
  }

  saveImage() {
    const formData = new FormData();
    formData.append('img', this.croppedImage);

    this.userService.uploadPhoto(formData).subscribe(resp => {
      if (resp.success) {
        this.router.navigate(['/my-account/my-details']);
      }
    });
  }

}
